import axios from "axios";
// 给请求地址前加一个"/api"，在请求头中添加Token

// const instance = axios.create({
//   baseURL: "/api",
// });
// // 添加返回拦截器，直接获取返回内容的data
// instance.interceptors.response.use((res) => {
//   return res.data;
// });


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
// ---------------------------------------------

const instance = axios.create({
  baseURL: API_BASE_URL, // 使用动态的 baseURL
  withCredentials: true,
  timeout: 10000, // 10秒超时
});
// 添加返回拦截器，直接获取返回内容的data
instance.interceptors.response.use((res) => {
  return res.data;
});

//专门处理文件下载的方法
export const downloadFile = (url) => {
  return new Promise((resolve, reject) => {
    instance({
      method: "get",
      url: url,
      responseType: "blob", // 关键：指定响应类型为 blob
    })
      .then((response) => {
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve();
      })
      .catch((err) => {
        console.error("下载失败:", err);
        reject(err);
      });
  });
};
